(function () {
    'use strict';

    angular.module('swif.interventions')
    .controller('RequestRefuseModalController', RequestRefuseModalController);

    function RequestRefuseModalController($scope, openstc, swifOpenbaseCompanyService) {
        'ngInject';
        console.log('init RequestRefuseModalController');
        $scope.filters = {
            intervention_category: {},
            department: {},
            task_category: {}
        };
        updateFilters();
        $scope.$watch('model.date_deadline', watchDateDeadline);
        $scope.$watch('model.service_id', watchServiceId);
        $scope.$watch('model.create_task', watchCreateTask);

        function watchDateDeadline(newV) {
            if (_.isEmpty(newV)) {
                $scope.model.date_deadline = moment().add(1, 'week').format('YYYY-MM-DD');
            }
        }
        function updateFilters (){
            $scope.filters = openstc.request.getFilters($scope.model);
        }
        function watchServiceId (newValue, oldValue) {
            if (newValue.length === oldValue.length && newValue.length === 2) {
                if (newValue[0] !== oldValue[0]) {
                    updateFilters();
                }
            }
        }
        function watchCreateTask(newValue) {
            if (newValue) {
                swifOpenbaseCompanyService.getGlobalSettings().then(function(company) {
                    $scope.model.planned_hours = company.task_default_hours;
                });
                $scope.model.task_category = false;
            } else {
                delete $scope.model.planned_hours;
                delete $scope.model.task_category;
            }
        }
    }


})();
